import React from 'react'
import MobilePlaySpots from '../../mobileView/playSpots/MobilePlaySpots'

const MobPlaySpots = () => {
  return (
    <div>
        <MobilePlaySpots />
    </div>
  )
}

export default MobPlaySpots